module.exports = __webpack_public_path__ + "img/planning.63776beb.jpeg";